import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=8bcbeaaa&scoped=true&"
import script from "./Make.vue?vue&type=script&lang=js&"
export * from "./Make.vue?vue&type=script&lang=js&"
import style0 from "./Make.vue?vue&type=style&index=0&id=8bcbeaaa&scoped=true&lang=css&"
import style1 from "./Make.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcbeaaa",
  null
  
)

export default component.exports